import React from 'react';
import PropTypes from 'prop-types';
import { typeLocation } from '../../types';
import HeaderNotFound from '../header/header-notfound';
import './style.less';
export var isOutsideLocation = function isOutsideLocation(urlBase, location) {
  var reg = new RegExp("^".concat(urlBase));
  return !reg.test(location.pathname);
};

var NotFound = function NotFound(_ref) {
  var urlBase = _ref.urlBase,
      location = _ref.location;

  if (isOutsideLocation(urlBase, location)) {
    window.location = "".concat(location.pathname).concat(location.search).concat(location.hash);
    return;
  }

  var clsPrefix = 'p-notfound';
  return /*#__PURE__*/React.createElement("div", {
    className: clsPrefix
  }, /*#__PURE__*/React.createElement(HeaderNotFound, null), /*#__PURE__*/React.createElement("div", {
    className: "".concat(clsPrefix, "--content")
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(clsPrefix, "--img")
  }), /*#__PURE__*/React.createElement("div", {
    className: "".concat(clsPrefix, "--right")
  }, /*#__PURE__*/React.createElement("h2", null, "\u5440\uFF0C \u8FD9\u4E2A\u9875\u9762\u627E\u4E0D\u5230\u4E86..."), /*#__PURE__*/React.createElement("h5", null, "\u53EF\u80FD\u6709\u5916\u661F\u4EBA\u5728\u52AB\u6301\u4FE1\u53F7\u54E6\uFF0C\u5FEB\u6253\u5F00\u7A97\u6237\u770B\u770B"), /*#__PURE__*/React.createElement("div", {
    className: "".concat(clsPrefix, "--links")
  }, /*#__PURE__*/React.createElement("a", {
    href: "/"
  }, "\u8FD4\u56DE\u9996\u9875"), /*#__PURE__*/React.createElement("a", {
    role: "button",
    tabIndex: 0,
    onClick: function onClick() {
      window.history.go(-1);
    }
  }, "\u8FD4\u56DE\u4E0A\u4E00\u9875")), /*#__PURE__*/React.createElement("ul", {
    className: "".concat(clsPrefix, "--ul")
  }, /*#__PURE__*/React.createElement("li", null, "\u6CA1\u627E\u5230\u60A8\u8981\u8BBF\u95EE\u7684\u7F51\u9875\uFF0C \u539F\u56E0\u53EF\u80FD\u5982\u4E0B\uFF1A"), /*#__PURE__*/React.createElement("li", null, "\u53EF\u80FD\u7F51\u901F\u8FC7\u6162, \u6216\u7F51\u7EDC\u4E2D\u65AD"), /*#__PURE__*/React.createElement("li", null, "\u53EF\u80FD\u9875\u9762\u5DF2\u88AB\u5220\u9664"), /*#__PURE__*/React.createElement("li", null, "\u8FD9\u4E2A\u9875\u9762\u592A\u53D7\u6B22\u8FCE\u4E86\uFF0C\u592A\u591A\u4EBA\u5728\u8BBF\u95EE")))));
};

NotFound.defaultProps = {
  urlBase: '/'
};
NotFound.propTypes = {
  urlBase: PropTypes.string,
  location: typeLocation.isRequired
};
export default NotFound;